import { Moon, Sun } from "lucide-react";
import { useTheme } from "../hooks/useTheme";

interface ThemeToggleProps {
  className?: string;
  size?: number;
}

export function ThemeToggle({ className, size = 18 }: ThemeToggleProps) {
  const { isDark, toggle } = useTheme();
  return (
    <button
      onClick={toggle}
      className={
        className ||
        "p-2 rounded-lg hover:bg-slate-100 transition-colors text-slate-600"
      }
      aria-label={isDark ? "Mudar para tema claro" : "Mudar para tema escuro"}
      title={isDark ? "Tema claro" : "Tema escuro"}
    >
      {isDark ? <Sun size={size} /> : <Moon size={size} />}
    </button>
  );
}
